import { translitToRus } from 'app/utils';
import { createSelector } from 'reselect';

const mapState = (state) => state.map;

export const refMapSelector = createSelector(mapState, (map) => map.ref);
export const zoomMapSelector = createSelector(mapState, (map) => map.zoom);
export const boundsMapSelector = createSelector(mapState, (map) => map.bounds);
export const layerSelectedMapSelector = createSelector(mapState, (map) => map.layerSelected);
export const geofenceModeMapSelector = createSelector(mapState, (map) => map.geofenceMode);
export const activeWindowMapSelector = createSelector(mapState, (map) => map.activeWindow);
export const transportWindowMinimizeMapSelector = createSelector(mapState, (map) => map.transportWindowMinimize);
export const transportTabMapSelector = createSelector(mapState, (map) => map.transportTab);
export const filterTabMapSelector = createSelector(mapState, (map) => map.filterTab);
export const transportItemsMapSelector = createSelector(mapState, (map) => map.transportItems);
export const transportSelectedItemMapSelector = createSelector(mapState, (map) => map.transportSelectedItem);
export const transportSelectedDateMapSelector = createSelector(mapState, (map) => map.transportSelectedDate);
export const transportConditionItemsMapSelector = createSelector(mapState, (map) => map.transportConditionItems);
export const transportFilterCheckedTypeMapSelector = createSelector(mapState, (map) => map.transportFilterCheckedType);
export const transportCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportCheckedItems);
export const transportMarkedCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportMarkedCheckedItems);
export const transportProcessingCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportProcessingCheckedItems);
export const transportSortSelectedItemMapSelector = createSelector(mapState, (map) => map.transportSortSelectedItem);
export const transportFilterCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportFilterCheckedItems);
export const transportColumnCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportColumnCheckedItems);
export const transportConditionFilterCheckedTypeMapSelector = createSelector(mapState, (map) => map.transportConditionFilterCheckedType);
export const transportConditionFilterCheckedItemsMapSelector = createSelector(mapState, (map) => map.transportConditionFilterCheckedItems);
export const transportBroadcastSelectedItemMapSelector = createSelector(mapState, (map) => map.transportBroadcastSelectedItem);
export const transportConditionSelectedItemMapSelector = createSelector(mapState, (map) => map.transportConditionSelectedItem);
export const transportConditionSelectedDatetimeMapSelector = createSelector(mapState, (map) => map.transportConditionSelectedDatetime);
export const transportActivityQueueMapSelector = createSelector(mapState, (map) => map.transportActivityQueue);
export const transportConditionQueueMapSelector = createSelector(mapState, (map) => map.transportConditionQueue);
export const transportSearchValueMapSelector = createSelector(mapState, (map) => map.transportSearchValue);
export const transportGeofenceViewMapSelector = createSelector(mapState, (map) => map.transportGeofenceView);
export const geofenceItemsMapSelector = createSelector(mapState, (map) => map.geofenceItems);
export const geofenceUpdatedItemMapSelector = createSelector(mapState, (map) => map.geofenceUpdatedItem);
export const geofenceChangedItemMapSelector = createSelector(mapState, (map) => map.geofenceChangedItem);
export const geofenceUpdatedModeMapSelector = createSelector(mapState, (map) => map.geofenceUpdatedMode);
export const geofenceCheckedIdMapSelector = createSelector(mapState, (map) => map.geofenceCheckedId);
export const geofenceGroupItemsMapSelector = createSelector(mapState, (map) => map.geofenceGroupItems);
export const geofenceGroupItemsLimitMapSelector = createSelector(mapState, (map) => map.geofenceGroupItemsLimit);
export const geofenceSearchValueMapSelector = createSelector(mapState, (map) => map.geofenceSearchValue);
export const taskItemsMapSelector = createSelector(mapState, (map) => map.taskItems);
export const taskSelectedItemMapSelector = createSelector(mapState, (map) => map.taskSelectedItem);
export const taskSortSelectedItemMapSelector = createSelector(mapState, (map) => map.taskSortSelectedItem);
export const taskFilterCheckedItemsMapSelector = createSelector(mapState, (map) => map.taskFilterCheckedItems);
export const taskColumnCheckedItemsMapSelector = createSelector(mapState, (map) => map.taskColumnCheckedItems);
export const taskSearchValueMapSelector = createSelector(mapState, (map) => map.taskSearchValue);
export const notificationEventsMapSelector = createSelector(mapState, (map) => map.notificationEvents);

export const transportSelectedItemBroadcastMapSelector = createSelector(transportSelectedItemMapSelector, (transportSelectedItem) => transportSelectedItem.broadcast);
export const transportSelectedItemConditionsMapSelector = createSelector(transportSelectedItemMapSelector, (transportSelectedItem) => transportSelectedItem.conditions);

export const sortItemsFilterGeofenceListSelector = createSelector([geofenceGroupItemsMapSelector, geofenceSearchValueMapSelector], (geofenceGroupItems, geofenceSearchValue) => {
    return geofenceGroupItems.map((currentValue) => {
        if (geofenceSearchValue.length !== 0) {
            return currentValue.geofences.filter((geofence) => translitToRus(geofence.name).indexOf(translitToRus(geofenceSearchValue)) !== -1);
        }

        return currentValue;
    });
});

export const sortItemsFlatMapSelector = createSelector([sortItemsFilterGeofenceListSelector, geofenceSearchValueMapSelector], (sortItems, geofenceSearchValue) => {
    const flat = sortItems.flat();
    if (geofenceSearchValue.length === 0) {
        return [...flat].sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }));
    }
    const searchNorm = translitToRus(geofenceSearchValue).toLowerCase();
    const itemsWithMeta = flat.map((item) => {
        const name = item.name || '';
        const nameTranslit = translitToRus(name).toLowerCase();
        return {
            item,
            name,
            nameTranslit,
            startsWithSearch: nameTranslit.startsWith(searchNorm),
        };
    });
    return itemsWithMeta
        .sort((a, b) => {
            if (a.startsWithSearch && !b.startsWithSearch) return -1;
            if (!a.startsWithSearch && b.startsWithSearch) return 1;

            return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
        })
        .map((meta) => meta.item);
});

export const sortItemsTaskListMapSelector = createSelector([taskItemsMapSelector, taskFilterCheckedItemsMapSelector, taskSortSelectedItemMapSelector, taskSearchValueMapSelector], (taskItems, taskFilterCheckedItems, taskSortSelectedItem, taskSearchValue) => {
    const compareFn = (a, b) => {
        switch (taskSortSelectedItem.name) {
            case 'transport_number':
                switch (taskSortSelectedItem.order) {
                    case 'ASC':
                        return a.transport_number.localeCompare(b.transport_number, { sensitivity: 'base' });
                    case 'DESC':
                        return b.transport_number.localeCompare(a.transport_number, { sensitivity: 'base' });
                }
                break;
            case 'task_date':
            case 'finished_date':
                switch (taskSortSelectedItem.order) {
                    case 'ASC':
                        return moment(a[taskSortSelectedItem.name]) - moment(b[taskSortSelectedItem.name]);
                    case 'DESC':
                        return moment(b[taskSortSelectedItem.name]) - moment(a[taskSortSelectedItem.name]);
                }
                break;
            default:
                switch (typeof a[taskSortSelectedItem.name]) {
                    case 'string':
                        switch (taskSortSelectedItem.order) {
                            case 'ASC':
                                return a.status.localeCompare(b.status, {
                                    sensitivity: 'base',
                                });
                            case 'DESC':
                                return b.status.localeCompare(a.status, {
                                    sensitivity: 'base',
                                });
                        }
                        break;
                    case 'number':
                        switch (taskSortSelectedItem.order) {
                            case 'ASC':
                                return a[taskSortSelectedItem.name] - b[taskSortSelectedItem.name];
                            case 'DESC':
                                return b[taskSortSelectedItem.name] - a[taskSortSelectedItem.name];
                        }
                        break;
                }
        }
    };

    const items = taskItems.reduce((accumulator, currentValue) => {
        if (accumulator.findIndex((item) => item.id === currentValue.id) !== -1) {
            return accumulator;
        }

        if (taskFilterCheckedItems.indexOf('active') !== -1) {
            if (currentValue.status === 'active') {
                return [...accumulator, currentValue];
            }
        }
        if (taskFilterCheckedItems.indexOf('finished') !== -1) {
            if (currentValue.status === 'finished') {
                return [...accumulator, currentValue];
            }
        }
        return accumulator;
    }, []);

    if (taskSearchValue.length) {
        return items.filter((item) => translitToRus(item.transport_number).indexOf(translitToRus(taskSearchValue)) !== -1).sort(compareFn);
    }

    return items.sort(compareFn);
});

export const transportCheckedItemsWithTypeMapSelector = createSelector([transportFilterCheckedTypeMapSelector, transportProcessingCheckedItemsMapSelector, transportCheckedItemsMapSelector], (type, transportProcessingCheckedItems, transportCheckedItems) => {
    if (type === 'filter') {
        return transportProcessingCheckedItems;
    }
    return transportCheckedItems;
});

export const sortItemsFilterTransportListMapSelector = createSelector(
    [transportItemsMapSelector, transportFilterCheckedItemsMapSelector, transportSortSelectedItemMapSelector],
    (datetimeInterval) => datetimeInterval,
    (transportItems, transportFilterCheckedItems, transportSortSelectedItem, datetimeInterval) => {
        const compareFn = (a, b) => {
            switch (transportSortSelectedItem.name) {
                case 'name':
                    switch (transportSortSelectedItem.order) {
                        case 'ASC':
                            return a.name.localeCompare(b.name, {
                                sensitivity: 'base',
                            });
                        case 'DESC':
                            return b.name.localeCompare(a.name, {
                                sensitivity: 'base',
                            });
                    }
                    break;
                case 'condition':
                    switch (transportSortSelectedItem.order) {
                        case 'ASC':
                            return moment(b.condition) - moment(a.condition);
                        case 'DESC':
                            return moment(a.condition) - moment(b.condition);
                    }
                    break;
                case 'geofence':
                    switch (transportSortSelectedItem.order) {
                        case 'ASC':
                            return b.geofence_id === config.conditions.geofence_id.default
                                ? -1
                                : a.geofence_id === config.conditions.geofence_id.default
                                  ? 1
                                  : a.geofence_name.localeCompare(b.geofence_name, { sensitivity: 'base' }) ||
                                    a.name.localeCompare(b.name, {
                                        sensitivity: 'base',
                                    });
                        case 'DESC':
                            return b.geofence_id === config.conditions.geofence_id.default
                                ? -1
                                : a.geofence_id === config.conditions.geofence_id.default
                                  ? 1
                                  : b.geofence_name.localeCompare(a.geofence_name, { sensitivity: 'base' }) ||
                                    b.name.localeCompare(a.name, {
                                        sensitivity: 'base',
                                    });
                    }
                    break;
                case 'parking_time':
                case 'sensor_count':
                    switch (transportSortSelectedItem.order) {
                        case 'ASC':
                            return b[transportSortSelectedItem.name] === config.conditions[transportSortSelectedItem.name].default
                                ? -1
                                : a[transportSortSelectedItem.name] === config.conditions[transportSortSelectedItem.name].default
                                  ? 1
                                  : a[transportSortSelectedItem.name] - b[transportSortSelectedItem.name];
                        case 'DESC':
                            return b[transportSortSelectedItem.name] === config.conditions[transportSortSelectedItem.name].default
                                ? -1
                                : a[transportSortSelectedItem.name] === config.conditions[transportSortSelectedItem.name].default
                                  ? 1
                                  : b[transportSortSelectedItem.name] - a[transportSortSelectedItem.name];
                    }
                    break;
                case 'signal_off':
                case 'guard_status_sum':
                case 'total_mileage_avg':
                    switch (transportSortSelectedItem.order) {
                        case 'ASC':
                            return b[transportSortSelectedItem.name] === null ? -1 : a[transportSortSelectedItem.name] === null ? 1 : a[transportSortSelectedItem.name] - b[transportSortSelectedItem.name];
                        case 'DESC':
                            return b[transportSortSelectedItem.name] === null ? -1 : a[transportSortSelectedItem.name] === null ? 1 : b[transportSortSelectedItem.name] - a[transportSortSelectedItem.name];
                    }
                    break;
                case 'last_activity_date':
                    switch (transportSortSelectedItem.order) {
                        case 'ASC':
                            return b[transportSortSelectedItem.name] === null
                                ? -1
                                : a[transportSortSelectedItem.name] === null
                                  ? 1
                                  : Math.round(moment(datetimeInterval).diff(moment(a[transportSortSelectedItem.name])) / 1000 / 60) - Math.round(moment(datetimeInterval).diff(moment(b[transportSortSelectedItem.name])) / 1000 / 60);
                        case 'DESC':
                            return b[transportSortSelectedItem.name] === null
                                ? -1
                                : a[transportSortSelectedItem.name] === null
                                  ? 1
                                  : Math.round(moment(datetimeInterval).diff(moment(b[transportSortSelectedItem.name])) / 1000 / 60) - Math.round(moment(datetimeInterval).diff(moment(a[transportSortSelectedItem.name])) / 1000 / 60);
                    }
                    break;
            }
        };

        const items = transportItems.reduce((accumulator, currentValue) => {
            if (accumulator.findIndex((item) => item.id === currentValue.id) !== -1) {
                return accumulator;
            }

            // Если включен фильтр «Активность».
            if (transportFilterCheckedItems.indexOf('activity') !== -1) {
                // Исключаем записи с временной меткой превышающей лимит.
                if (!currentValue.last_activity_date || moment(datetimeInterval).diff(moment(currentValue.last_activity_date)) < config.activityTimeout) {
                    return accumulator;
                }
            }

            // Установим дополнительные параметры для отображения сортировки.
            currentValue = {
                ...currentValue,
                ...{
                    datetime: '',
                    geofence_name: 'NA',
                    geofence_id: config.conditions.geofence_id.default,
                    guard_status: config.conditions.guard_status.default,
                    parking_time: config.conditions.parking_time.default,
                    sensor_count: config.conditions.sensor_count.default,
                    guard_status_sum: null,
                    signal_off: null,
                    condition: null,
                },
            };

            if (currentValue.conditions.length === 0) {
                return transportFilterCheckedItems.indexOf('signal') !== -1 ? [...accumulator, currentValue] : accumulator;
            }

            // Преобразуем исходное десятичное число к двоичному числу, помещенному в массив [9 8765 4321] -> guard_out9...guard_out1.
            // Получим сумму значений всех dut, обращаясь к каждому как к dutN.
            const guard_out = (currentValue.conditions[currentValue.conditions.length - 1].data.guard_out >>> 0).toString(2).padStart(9, '0');
            const guard_status = (currentValue.conditions[currentValue.conditions.length - 1].data.guard_status >>> 0).toString(2).padStart(9, '0');

            currentValue.datetime = currentValue.conditions[currentValue.conditions.length - 1].datetime;
            currentValue.geofence_id = currentValue.conditions[currentValue.conditions.length - 1].data.geofence_id;
            currentValue.geofence_name = currentValue.conditions[currentValue.conditions.length - 1].data.geofence_name;
            currentValue.guard_status = (currentValue.conditions[currentValue.conditions.length - 1].data.guard_status >>> 0).toString(2).padStart(9, '0');
            currentValue.guard_status_sum = config.numberOfTank
                .map((number) => currentValue.conditions[currentValue.conditions.length - 1].data[`dut${number}`])
                .filter((number) => number !== config.conditions.dut.default)
                .reduce((a, b) => a + b, 0);
            currentValue.total_mileage_avg = currentValue.conditions[currentValue.conditions.length - 1].data.total_mileage_avg;
            currentValue.parking_time = currentValue.conditions[currentValue.conditions.length - 1].data.parking_time;
            currentValue.sensor_count = currentValue.conditions[currentValue.conditions.length - 1].data.sensor_count;
            currentValue.signal_off = Math.max(0, moment(datetimeInterval).diff(moment(currentValue.conditions[currentValue.conditions.length - 1].datetime).endOf('minute')));
            currentValue.condition = Math.max(...currentValue.conditions[currentValue.conditions.length - 1].filters.filter((filter) => transportFilterCheckedItems.indexOf(filter.name) !== -1).map((filter) => new Date(filter.datetime)));

            // Принудительный фильтр для отображения в списке.
            // Общее количество фильтров за исключением активности.
            if (transportFilterCheckedItems.length >= config.mapTransportFilters.length - 1) {
                return [...accumulator, currentValue];
            }

            // Если включен фильтр «Охрана».
            if (transportFilterCheckedItems.indexOf('guard') !== -1) {
                if (currentValue.conditions[currentValue.conditions.length - 1].data.guard_out !== config.conditions.guard_out.default) {
                    // Проверить guard_out8
                    switch (guard_out[1]) {
                        case '1':
                            return [...accumulator, currentValue];
                    }
                }
            }

            // Если включен фильтр «Тревога».
            if (transportFilterCheckedItems.indexOf('alarm') !== -1) {
                if (currentValue.conditions[currentValue.conditions.length - 1].data.guard_status !== config.conditions.guard_status.default) {
                    // Проверить guard_status8
                    switch (guard_status[1]) {
                        case '1':
                            return [...accumulator, currentValue];
                    }
                }
            }

            // Если включен фильтр «Слив».
            if (transportFilterCheckedItems.indexOf('drain') !== -1) {
                if (currentValue.conditions[currentValue.conditions.length - 1].data.geofence_name !== 'NA') {
                    switch (currentValue.conditions[currentValue.conditions.length - 1].data.geofence_type) {
                        case 1:
                            // Проверить guard_status7
                            switch (guard_status[2]) {
                                case '1':
                                    return [...accumulator, currentValue];
                            }
                    }
                }
            }

            // Если включен фильтр «Налив».
            if (transportFilterCheckedItems.indexOf('pouring') !== -1) {
                if (currentValue.conditions[currentValue.conditions.length - 1].data.geofence_name !== 'NA') {
                    switch (currentValue.conditions[currentValue.conditions.length - 1].data.geofence_type) {
                        case 3:
                            return [...accumulator, currentValue];
                    }
                }
            }

            // Если включен фильтр «Парковка».
            if (transportFilterCheckedItems.indexOf('parking') !== -1) {
                switch (currentValue.conditions[currentValue.conditions.length - 1].data.is_parked) {
                    case 1:
                        return [...accumulator, currentValue];
                }
            }

            // Если включен фильтр «Движение».
            if (transportFilterCheckedItems.indexOf('speed') !== -1) {
                switch (currentValue.conditions[currentValue.conditions.length - 1].data.is_parked) {
                    case 0:
                        return [...accumulator, currentValue];
                }
            }

            // Если включен фильтр «Потеря связи».
            if (transportFilterCheckedItems.indexOf('signal') !== -1) {
                const diff = Math.max(
                    0,
                    moment().diff(
                        moment
                            .utc(currentValue.conditions[currentValue.conditions.length - 1].data.datetime)
                            .local()
                            .endOf('minute')
                    )
                );

                if (diff > config.signalOffTimeout[0].interval[1]) {
                    return [...accumulator, currentValue];
                }
            }

            // Если включен фильтр «Стоянка от 10 минут».
            if (transportFilterCheckedItems.indexOf('parking_time') !== -1) {
                if (currentValue.conditions[currentValue.conditions.length - 1].data.geofence_name === 'NA') {
                    switch (currentValue.conditions[currentValue.conditions.length - 1].data.parking_overtime) {
                        case 1:
                            switch (true) {
                                case currentValue.conditions[currentValue.conditions.length - 1].data.parking_time <= 21600:
                                    return [...accumulator, currentValue];
                            }
                    }
                }
            }

            return accumulator;
        }, []);

        return items.sort(compareFn);
    }
);

export const searchItemsTransportMapSelector = createSelector([sortItemsFilterTransportListMapSelector, transportSearchValueMapSelector, transportSortSelectedItemMapSelector], (sortItems, transportSearchValue, transportSortSelectedItem) => {
    if (transportSearchValue.length) {
        return sortItems.filter((item) => {
            if (transportSortSelectedItem.name === 'geofence') {
                return translitToRus(item.name).indexOf(translitToRus(transportSearchValue)) !== -1 || translitToRus(item.geofence_name).indexOf(translitToRus(transportSearchValue)) !== -1;
            }

            return translitToRus(item.name).indexOf(translitToRus(transportSearchValue)) !== -1;
        });
    }

    return sortItems;
});
